// deliveries-service.js — on-demand driver deliveries (DoorDash / Uber Eats).
import api_fetch from '../utils/api_fetch';
import { storageHandler } from '../utils/storage_handler';

const auth = () => ({
  Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
});

const deliveriesService = {
  /**
   * List deliveries with search + date range + pagination.
   * @param {Object} opts
   * @param {number} opts.page 1-indexed
   * @param {number} opts.limit
   * @param {string} opts.search matches po_number / serial_number / service / username
   * @param {string} opts.from ISO date (created_at >=)
   * @param {string} opts.to ISO date (created_at <=)
   * @param {string} opts.sortBy
   * @param {string} opts.sortOrder 'ASC' | 'DESC'
   */
  async list({
    page = 1,
    limit = 20,
    search = '',
    from = '',
    to = '',
    sortBy = 'createdAt',
    sortOrder = 'DESC'
  } = {}) {
    const query = { limit, offset: (page - 1) * limit };
    if (search) query.search = search;
    if (from) query.from = from;
    if (to) query.to = to;
    if (sortBy) query.sort_by = sortBy;
    if (sortOrder) query.sort_order = sortOrder;

    const res = await api_fetch.get('/v1/deliveries', auth(), query);
    return res.json();
  },

  async getById(id) {
    const res = await api_fetch.get(`/v1/delivery/${id}`, auth(), {});
    return res.json();
  },

  async remove(id) {
    const res = await api_fetch.delete(`/v1/delivery/${id}`, auth(), {}, '', {});
    return res.json();
  }
};

export default deliveriesService;
